<!-- @format -->
<template>
    <div :class="['call-popup', { 'on-hold': isOnHold }, { connected: isConnected }]">
        <call-connected
            :contact="contact"
            v-if="isConnected"
            @close="handleEndCall"
            @hold="handleHold"
        >
        </call-connected>
        <call-connecting :contact="contact" v-else @close="handleEndCall"></call-connecting>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus.js';
import { FroalaMixin } from '@/mixins/froala-mixin';
const CallConnecting = () => import('@/components/voip/call-connecting.vue');
const CallConnected = () => import('@/components/voip/call-connected.vue');

export default {
    name: 'call-popup',

    components: {
        'call-connecting': CallConnecting,
        'call-connected': CallConnected,
    },

    mixins: [FroalaMixin],

    provide() {
        return {};
    },

    props: {
        options: {
            type: Object,
            default: () => ({
                contactId: null,
            }),
        },
    },

    watch: {},

    data() {
        return {
            isOnHold: false,
            isConnected: false,
            contact: null,
            isLoading: false,
        };
    },

    async created() {
        setTimeout(() => {
            this.isConnected = true;
        }, 5000);
    },

    mounted() {
        this.getContactData();
    },

    beforeDestroy() {},

    methods: {
        closePopup() {
            this.$emit('close');
        },

        minimizePopup() {
            this.isCollapsed = !this.isCollapsed;
        },

        getContactData() {
            this.isLoading = true;
            return new Promise((resolve, reject) => {
                var restUrl = `/service/Contacts?$filter=Id eq ${this.options.contactId}`;
                this.$api
                    .get(restUrl)
                    .then((response) => {
                        this.contact = this.mapContact(response.data.value[0]);
                        resolve();
                    })
                    .catch(reject)
                    .finally(() => {
                        this.isLoading = false;
                    });
            });
        },

        mapContact(contact) {
            return {
                firstName: contact.FirstName,
                lastName: contact.LastName,
                email: contact.Email,
                profileImageUrl: contact.ProfileImageUrl || require('@/assets/images/avatar.png'),
                phone: contact.Phone,
            };
        },

        handleHold(isOnHold) {
            this.isOnHold = isOnHold;
        },

        handleEndCall() {
            this.$emit('close');
            EventBus.$emit('open-widget', {
                name: 'end-call-widget',
                contactId: this.options.contactId,
            });
        },
    },
};
</script>

<style>
.call-popup {
    width: 100%;
    height: 100%;
    background: var(--color-fill-bold);
    border-radius: 16px;
    pointer-events: all;
    border-radius: 16px;
}

.call-popup.on-hold .fr-toolbar.fr-top {
    background: linear-gradient(to right, #382153 0%, #877d88 100%) !important;
}
</style>
